import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {
  AlertStyledContainer,
  ExitPreviewButton,
  ExitPreviewText,
  MainTitleContainer,
  MainTitleContainerCenter,
  MainTitleContainerExitButton,
  MainTitleContainerEyeIcon,
  PreviewBanner,
  PreviewVisibiltiyOnIcon,
  TitleContainer,
  TitleContainerCenter,
  TitleContainerHeader,
  TitleContainerSubHeader,
} from './PreviewModal.styled';
import SectionTitle from './SectionTitle';
import LastEdited from './LastEdited';
import { VisibilityOnIcon } from './ActionBar.styled';
import { Alert, Box, Button, Text, Typography } from '@ublend-npm/aulaui-core';
import NoResultsCard from '@app/components/presentational/common/NoResults/NoResultsCard';
import PreviewContent from './PreviewContent';
import DiscussionArea from '../DiscussionArea/DiscussionArea';

const CustomExitPreviewButtonStyle = {
  cursor: 'pointer',
  padding: '6px',
  color: '#014361',
  borderRadius: '4px',
  backgroundColor: 'transparent',
  Border: 'none',
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme) => theme.palette.action.hover,
  },
};

class PreviewModal extends React.PureComponent {
  render() {
    const {
      open,
      onClose,
      previewData,
      section,
      onGetSection,
      setUploadState,
      onDiscussionSave,
      correlationId,
      permissions,
    } = this.props;

    if (!open || !previewData) {
      return null;
    }

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle sx={{ mb: 2 }}>
          <AlertStyledContainer>
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <VisibilityOnIcon sx={{ color: '#0288D1' }} />
              <TitleContainerCenter>
                <Text kind="p1" fontWeight={600} color="#014361">
                  Page Preview
                </Text>
                <Text kind="p2" color="#014361">
                  Preview this page as learners will see it.
                </Text>
              </TitleContainerCenter>
            </Box>
            <Button
              variant="text"
              onClick={onClose}
              sx={CustomExitPreviewButtonStyle}
            >
              Exit Preview
            </Button>
          </AlertStyledContainer>
        </DialogTitle>
        <DialogContent>
          <TitleContainer>
            <SectionTitle editable={false} value={previewData.title} />
          </TitleContainer>
          <LastEdited
            editedAt={section.updatedAt}
            createdAt={section.createdAt}
          />
          <PreviewContent
            content={previewData.content}
            correlationId={correlationId}
          />
          <DiscussionArea
            entityId={section.id}
            editable={false}
            discussionTopic={previewData.discussionTopic}
            showDiscussion={previewData.showDiscussion}
            permissions={permissions}
            isPreview={true}
          />
        </DialogContent>
      </Dialog>
    );
  }
}

PreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  previewData: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.object,
    discussionTopic: PropTypes.object,
    showDiscussion: PropTypes.bool,
  }),
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    updatedAt: PropTypes.string,
    createdAt: PropTypes.string,
  }).isRequired,
  onGetSection: PropTypes.func.isRequired,
  setUploadState: PropTypes.func.isRequired,
  onDiscussionSave: PropTypes.func.isRequired,
  correlationId: PropTypes.string.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string),
};

PreviewModal.defaultProps = {
  previewData: null,
  permissions: [],
};

export default PreviewModal;
